import {Injectable} from '@angular/core';
import {BaseApiService} from '../../../shared/base-service/base-api.service';

@Injectable()
export class FinanceSharedService extends BaseApiService {

    /**
     * The service constructor
     * @param modal
     */
    constructor() {
        super();
    }

    /**
     * Makes the API call to determine if a cash drawer must be confirmed.  If verification required calls the method to confirm with the user.
     */
    public checkCashDrawerVerified() {
        return this.get('Finance/CashDrawer/Verify');
    }

    /**
     * Sets the current users cash drawer to verified
     */
    public setCashDrawerVerified(cashDrawerVerificationData: any) {
        return this.post('Finance/CashDrawer/Status/Verify', cashDrawerVerificationData);
    }

    /**
     * Gets point of sale devices
     */
    public getPointOfSaleDevices() {
        return this.get('Finance/PointOfSale');
    }
}
